  addEventListener('DOMContentLoaded', (event) => {

    // Unified dropdown menu system for both top and bottom navigation (performance optimized)
    function initializeDropdownSystem() {
      // Initialize both navigation systems independently with cached navigation elements
      const topNavigation = document.querySelector('#AccessibleNav2');
      const bottomNavigation = document.querySelector('#AccessibleNav2Bottom');
      
      // Process both navigation menus
      [topNavigation, bottomNavigation].forEach(function(navElement) {
        if (!navElement) return;
        
        // Get all dropdown menus within this navigation
        const dropdownMenus = navElement.querySelectorAll('.site-nav--has-dropdown');
        
        dropdownMenus.forEach(function(menu) {
          const trigger = menu.querySelector('.site-nav__link');
          const dropdown = menu.querySelector('.site-nav__dropdown');
          
          if (trigger && dropdown) {
            // Add ARIA attributes for accessibility (only if missing)
            if (!trigger.getAttribute('aria-expanded')) {
              trigger.setAttribute('aria-expanded', 'false');
            }
            if (!trigger.getAttribute('aria-controls')) {
              const dropdownId = dropdown.id || 'dropdown-' + Math.random().toString(36).substr(2, 9);
              trigger.setAttribute('aria-controls', dropdownId);
              if (!dropdown.id) {
                dropdown.id = dropdownId;
              }
            }
            
            // Create optimized event handlers - cache references to avoid repeated DOM queries
            const handleMouseEnter = function() {
              closeAllOtherDropdowns(navElement, menu);
              openDropdown(menu, trigger, dropdown);
            };
            
            const handleMouseLeave = function() {
              closeDropdown(menu, trigger, dropdown);
            };
            
            const handleTouchClick = function(e) {
              // Only handle click on touch devices to avoid breaking hover behavior
              if (window.matchMedia('(hover: none)').matches) {
                e.preventDefault();
                toggleDropdown(navElement, menu, trigger, dropdown);
              }
            };
            
            const handleKeydown = function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleDropdown(navElement, menu, trigger, dropdown);
              } else if (e.key === 'Escape') {
                closeDropdown(menu, trigger, dropdown);
              }
            };
            
            // Mouse events for desktop hover behavior
            menu.addEventListener('mouseenter', handleMouseEnter, { passive: true });
            menu.addEventListener('mouseleave', handleMouseLeave, { passive: true });
            
            // Touch/Click device support
            trigger.addEventListener('click', handleTouchClick, { passive: false });
            
            // Keyboard accessibility
            trigger.addEventListener('keydown', handleKeydown);
          }
        });
      });
    }
    
    // Dropdown control functions optimized for dual navigation
    function openDropdown(menu, trigger, dropdown) {
      menu.classList.add('nav-hover');
      trigger.setAttribute('aria-expanded', 'true');
      // Keep focus on trigger for keyboard users
      if (document.activeElement === trigger) {
        trigger.focus();
      }
    }
    
    function closeDropdown(menu, trigger, dropdown) {
      menu.classList.remove('nav-hover');
      trigger.setAttribute('aria-expanded', 'false');
    }
    
    function closeAllOtherDropdowns(currentNav, currentMenu) {
      // Only close dropdowns that are actually open (performance optimization)
      currentNav.querySelectorAll('.site-nav--has-dropdown.nav-hover').forEach(function(otherMenu) {
        if (otherMenu !== currentMenu) {
          const otherTrigger = otherMenu.querySelector('.site-nav__link');
          const otherDropdown = otherMenu.querySelector('.site-nav__dropdown');
          if (otherTrigger && otherDropdown) {
            closeDropdown(otherMenu, otherTrigger, otherDropdown);
          }
        }
      });
    }
    
    function toggleDropdown(navElement, menu, trigger, dropdown) {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeAllOtherDropdowns(navElement, menu);
      
      if (isOpen) {
        closeDropdown(menu, trigger, dropdown);
      } else {
        openDropdown(menu, trigger, dropdown);
      }
    }
    
    // Initialize the dropdown system
    initializeDropdownSystem();
    
    // Close dropdowns when clicking outside (performance optimized)
    // Cache navigation elements to avoid repeated DOM queries
    const topNavCached = document.querySelector('#AccessibleNav2');
    const bottomNavCached = document.querySelector('#AccessibleNav2Bottom');
    
    document.addEventListener('click', function(e) {
      // Early exit if click is within navigation areas
      if (e.target.closest('#AccessibleNav2') || e.target.closest('#AccessibleNav2Bottom')) {
        return;
      }
      
      // Close open dropdowns more efficiently
      [topNavCached, bottomNavCached].forEach(function(navElement) {
        if (navElement) {
          const openDropdowns = navElement.querySelectorAll('.site-nav--has-dropdown.nav-hover');
          openDropdowns.forEach(function(menu) {
            const trigger = menu.querySelector('.site-nav__link');
            const dropdown = menu.querySelector('.site-nav__dropdown');
            if (trigger && dropdown) {
              closeDropdown(menu, trigger, dropdown);
            }
          });
        }
      });
    });

    // mobile menu js
    let topBar = document.querySelector('.top-bar-wrapper');
    let DrawerOverlay = document.querySelector('#DrawerOverlay') || document.querySelector('#NavDrawerOverlay');

    // Add null checks to prevent errors
    if (!DrawerOverlay) {
      console.warn('Required drawer overlay not found for mobile menu');
      return;
    }

    const drawerClose = function(){
      document.querySelector('body').classList.remove('js-drawer-open', 'js-drawer-open-left');
    }

    topBar.addEventListener('click', function(e){
      let drawerBtn = e.target.closest('.site-nav--mobile button');
      if(!drawerBtn) return;
      document.querySelector('body').classList.add('js-drawer-open', 'js-drawer-open-left');
    })

    topBar.addEventListener('click', function(e){
      let drawerCloseBtn = e.target.closest('.mobile-menu--close-btn');
      if(!drawerCloseBtn) return;
      drawerClose();
    })

  DrawerOverlay.addEventListener('click', drawerClose)

    topBar.addEventListener('click', function(e){
      let navLink = e.target.closest('.mobile-nav__item');
     
      if(!navLink) return;
      let hasDrop = navLink.getAttribute('aria-haspopup');
      let subList = navLink.querySelector('.mobile-nav__has-sublist');
      let btnDrop = e.target.closest('.mobile-nav__toggle button');
      if(!subList) return;
      if(btnDrop.getAttribute('aria-label') == 'See more' || btnDrop.getAttribute('name') == 'See more' ){
        
      subList.classList.add('mobile-nav--expanded');
      }else if(btnDrop.getAttribute('aria-label') == 'Close menu' || btnDrop.getAttribute('name') == 'Close menu' ){
        subList.classList.remove('mobile-nav--expanded');
      }

    })
    
  });
